import clsx from 'clsx'
import { CSSProperties } from 'react'
import Icon from '@/components/atoms/Icon'
import Flex from '@/components/atoms/Flex'
import { Heading, Label, Paragraph } from '@/components/atoms/Typography'

import { BoxItemProps } from './BoxItem.types'
import styles from './BoxItem.module.scss'

const BoxItem = ({
  highlighted = false,
  title,
  content,
  intro,
  note,
  image,
}: BoxItemProps) => {
  const customStyle: CSSProperties = {}
  if (!!image) {
    customStyle.backgroundImage = `url(${image.src})`
  }

  return (
    <div className={clsx(styles.box, highlighted && styles.highlighted)}>
      <div
        className={clsx(styles.boxContainer)}
        style={customStyle}
      >
        <div className={clsx(styles.header)}>
          <Paragraph
            as='div'
            size='xs'
            weight='regular'
            content={intro}
            dangerouslySetInnerHTML
          />
          <Paragraph
            size='xs'
            weight='bold'
          >
            {title}
          </Paragraph>
        </div>
        <div className={clsx(styles.main)}>
          <Heading
            as='h3'
            size={highlighted ? 'xl' : 'md'}
            weight={highlighted ? 'regular' : 'bold'}
            style={{
              fontFamily: highlighted ? 'Osmose, sans-serif' : 'inherit',
            }}
            content={content}
            dangerouslySetInnerHTML
          />
          <Flex
            className={styles.footer}
            gap='8px'
            direction='row'
            justifyContent='start'
            alignItems='center'
          >
            <Icon
              width={20}
              height={20}
              style={{ flexShrink: 0 }}
              iconName='Trophy'
            />
            <Label
              size='md'
              weight='bold'
            >
              {note}
            </Label>
          </Flex>
        </div>
      </div>
    </div>
  )
}

export default BoxItem
